import { v4 as uuidv4 } from 'uuid';

// Handle file upload and compression
const handleImageUpload = async (event, { setThumbnails, thumbnails, setImages }) => {

  const files = Array.from(event.target.files);

  const renamedFiles = files.map((file) => {
    const uuidName = uuidv4() + '.' + file.name.split('.').pop(); // zachováš príponu
    const renamedFile = new File([file], uuidName, { type: file.type });
    renamedFile.id = uuidv4(); // voliteľné, ak chceš id navyše
    return renamedFile;
  });

  console.log(renamedFiles);
  setImages((prev) => [...prev, ...renamedFiles]);

  const thumbnailsObjs = renamedFiles.map((file) => {
    return { fileURL: URL.createObjectURL(file), id: file.id, name: file.name}
  });

  setThumbnails((prev) => [...prev, ...thumbnailsObjs]);
};

export default handleImageUpload;